import React from 'react';
import { motion } from 'framer-motion';
import { Flame, AlertCircle, EyeOff, Frown, RefreshCw } from 'lucide-react';
export function PatternBreak() {
  const steps = [{
    icon: Flame,
    text: 'te emocionas',
    color: 'text-orange-500'
  }, {
    icon: AlertCircle,
    text: 'te exiges hacerlo perfecto',
    color: 'text-yellow-500'
  }, {
    icon: EyeOff,
    text: 'no ves resultados inmediatos',
    color: 'text-gray-400'
  }, {
    icon: Frown,
    text: 'te da vergüenza',
    color: 'text-red-400'
  }, {
    icon: RefreshCw,
    text: "cambias de rumbo para no sentirte 'tonto'",
    color: 'text-[#FE2C55]'
  }];
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-187">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} data-id="element-188">
        <h2 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-189">
          La razón por la que no vendes no es TikTok… <br data-id="element-190" />
          <span className="text-[#FE2C55]" data-id="element-191">eres tú (pero no como crees)</span>
        </h2>

        <div className="bg-[#111] p-8 rounded-3xl border border-white/5 relative overflow-hidden" data-id="element-192">
          <p className="text-xl font-semibold text-white mb-8 text-center" data-id="element-193">
            Tu patrón es:
          </p>

          <div className="relative space-y-8 before:absolute before:left-[19px] before:top-4 before:bottom-4 before:w-0.5 before:bg-white/10" data-id="element-194">
            {steps.map((step, index) => <div key={index} className="relative flex items-center gap-4" data-id="element-195">
                <div className={`relative z-10 w-10 h-10 rounded-full bg-[#1A1A1A] border border-white/10 flex items-center justify-center ${step.color}`} data-id="element-196">
                  <step.icon className="w-5 h-5" data-id="element-197" />
                </div>
                <div className="flex-1" data-id="element-198">
                  <span className="text-xs font-mono text-gray-500 mb-1 block" data-id="element-199">
                    PASO {index + 1}
                  </span>
                  <p className="text-lg text-gray-200" data-id="element-200">{step.text}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-10 p-6 bg-[#25F4EE]/5 border-l-4 border-[#25F4EE] rounded-r-xl" data-id="element-201">
          <p className="text-xl md:text-2xl font-bold text-white leading-tight" data-id="element-202">
            El sprint corta ese patrón con una regla simple: <br data-id="element-203" />
            <span className="text-[#25F4EE]" data-id="element-204">
              1 micro-acción al día. 14 días. Sin negociar.
            </span>
          </p>
        </div>
      </motion.div>
    </section>;
}